const copyButtons = () => {
    const copyButtons = document.querySelectorAll('[data-copy-button]');
    copyButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const toolTip = button.querySelector('[data-copy-tooltop]');
            const copyString = button.getAttribute('data-copy-value');
            if (copyString) {
                toolTip.innerHTML = 'Copied: ' + copyString;
                navigator.clipboard.writeText(copyString);
                setTimeout(() => {
                    toolTip.innerHTML = 'Copy to clipboard';
                }, 750);
            }
        });
    });
};
export { copyButtons };
